import { Component, OnInit } from '@angular/core';
import { SubSink } from 'subsink';
import { DrugSearchURLService } from './services/drug-search-url.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'angular-project';
  showAlert = false;
  alertMessage: string;
  subs = new SubSink();

  constructor(private _drugSearchURLService: DrugSearchURLService) {}
  ngOnInit(): void {
    this.showAlert = false;
    this.subs.add(this._drugSearchURLService.getMessages().subscribe(res => {
      if (res.status === 0) {
        res.data.forEach(val => {
          this._drugSearchURLService.messageKeyValueMap.set(val.key, val.value);
        },
          (err) => {
            console.log(err);
          })
      }
    }));
  }
err
  closeAlert() {
    this.showAlert = false;
  }

  isValidPlan(event) {
    this.showAlert = true;
    this.alertMessage = event;
  }
}
